import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=7800f7e8&"
import script from "./EventCard.vue?vue&type=script&lang=js&"
export * from "./EventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports